<script>
import { mapActions } from 'vuex';
import { SET_SIDEBAR, UNSET_SIDEBAR } from '@/store/types';

export default {
  name: 'WithCustomSidebar',
  props: {
    config: {
      type: Object,
      required: true,
    },
  },

  watch: {
    config: {
      immediate: true,

      handler(config) {
        if (config) this.setSidebar(config);
      },
    },
  },

  beforeDestroy() {
    this.unsetCurrentSidebar();
  },

  methods: {
    ...mapActions({
      setSidebar: SET_SIDEBAR,
      unsetCurrentSidebar: UNSET_SIDEBAR,
    }),
  },

  render() {
    return this.$slots.default;
  },
};
</script>
